import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';
import { Button, Disclosure, DisclosurePanel, DisclosureTrigger } from '@gitbook/spine-react';

import { BlockLayout } from '../BlockLayout';
import { EditorWidthLayout } from '../contexts';

/**
 * Renderer for a diff-unmodified block.
 * By default its content is collapsed.
 */
export function BlockDiffUnmodified(props: BlockProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <BlockLayout renderMode="centered">
            <EditorWidthLayout.View>
                <Disclosure>
                    {({ isExpanded }) => (
                        <div {...attributes} className="flex w-full flex-col">
                            {isExpanded ? null : (
                                <DisclosureTrigger>
                                    <Button
                                        label="Expand unchanged content"
                                        kind="blank"
                                        size="medium"
                                        iconOnly
                                        leadingIcon={Icon.Unfold}
                                    />
                                </DisclosureTrigger>
                            )}
                            <DisclosurePanel>{children}</DisclosurePanel>
                        </div>
                    )}
                </Disclosure>
            </EditorWidthLayout.View>
        </BlockLayout>
    );
}
